import { Fragment } from 'react'

export const isString = (obj: any): boolean => {
  return typeof obj == 'string' || obj instanceof String
}

export const isMatchedPartial = (text: string, search: string): boolean => {
  return text.indexOf(search) >= 0
}

export const stringBytes = (text: string) => {
  return encodeURIComponent(text).replace(/%../g, 'x').length
}

export const lineToBreak = (message: string) => {
  return message
    ? message.split(/(\n)/).map((item, index) => {
        return <Fragment key={index}>{item.match(/\n/) ? <br /> : item}</Fragment>
      })
    : ``
}

export const removeBreak = (str: string) => {
  return str.replace(/\r?\n/g, '')
}

export const insertText = (str: string, index: number, value: string) => {
  return str.substring(0, index) + value + str.substring(index)
}
